import { render, staticRenderFns } from "./classAlbumRecord.vue?vue&type=template&id=6d6a3e80&scoped=true&"
import script from "./classAlbumRecord.vue?vue&type=script&lang=js&"
export * from "./classAlbumRecord.vue?vue&type=script&lang=js&"
import style0 from "./classAlbumRecord.vue?vue&type=style&index=0&id=6d6a3e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6a3e80",
  null
  
)

export default component.exports